module.exports = __webpack_public_path__ + "img/facilityInfo_3_7.97ccd204.jpg";